/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import AutocompleteSelect from "../../../../Basis/Components/Autocomplete/AutocompleteSelect";
import Schriftart, { Schriftarten } from "../../Queries/Schriftart";
import SchriftartSelectProps from "./SchriftartSelectProps";

const SCHRIFTARTEN = [

    Schriftarten.arimo,
    Schriftarten.roboto,
    Schriftarten.tinos,
    Schriftarten.openSans,
];

export default function SchriftartSelect(props: SchriftartSelectProps) {
    const toTitleCase = (text: string) => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase();

    const getStyle = (schriftart: Schriftart | null) => ({
        fontFamily: toTitleCase(schriftart ?? Schriftarten.roboto),
    });

    return (
        <AutocompleteSelect<Schriftart>
            {...props}
            getOptionLabel={(o) => o}
            renderOption={(o) => <span style={getStyle(o)}>{o === 'OPENSANS' ? 'Open Sans' : toTitleCase(o ?? "")}</span>}
            executeQuery={() => Promise.resolve(SCHRIFTARTEN)}
            filterOptions={(options, state) => {
                return SCHRIFTARTEN.filter(schriftart => {
                    return schriftart.toLowerCase().includes(state.inputValue.toLowerCase());
                });
            }}
            getOptionSelected={(option: Schriftart, value: Schriftart) => {
                return option === value;
            }}
        />
    );
}
